
import axios from 'axios';
import { link } from '../Constants';
const sendOtp = async (email,language, recaptchaToken) => {
  try {
    const response = await fetch(link + '/otp', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Rechaptcha-Response': recaptchaToken
      },
      body: JSON.stringify({ email,language }),
    });
    if (!response.ok) {
      if (response.status === 409) {
        throw new Error('Application for ' + email + ' already exists'
        );
      }
     
      throw new Error('Failed to send OTP');
    }

    return response.ok;
  } catch (error) {
    console.error('Error sending OTP:', error);
    throw error;
  }
};

const verifyOtp = async (email, otp, recaptchaToken) => {
  let headers = {};

  if (recaptchaToken) {
    headers['Rechaptcha-Response'] = recaptchaToken;
  }

  try {
    const response = await axios.post(
      link+ '/otp/verify',
      {
        email: email,
        otp: otp,
      },
      { headers }
    );
    if (response.status !== 200) {
      throw new Error('Failed to verify OTP');
    }
    return response.data;
  } catch (error) {
    console.error('Error verifying OTP:', error.response?.data?.message || error.message);
    throw error;
  }
};

export { sendOtp, verifyOtp };
